import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Alert, Button, Form, Input, Typography } from "antd";
import dayjs from "dayjs";
import { FiLock, FiUser } from "react-icons/fi";
import SplashScreen from "../../components/splash";
import {
	removeHtmlStorage,
	setHtmlStorage,
	statusHtmlStorage,
} from "../../config/helper";
import { authSignin } from "../../store/auth/action";
import styles from "./signin.module.css";

class SignIn extends Component {
	constructor(props) {
		super(props);
		this.state = {
			alertState: {
				show: false,
				variant: "error",
				message: "",
			},
			username: "",
			password: "",
			fieldUsername: {
				show: false,
				status: "",
				message: "",
			},
			fieldPassword: {
				show: false,
				status: "",
				message: "",
			},
		};
		this.handleSignInForm = this.handleSignInForm.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
	}

	async componentDidMount() {
		if (statusHtmlStorage("resendEmail")) {
			removeHtmlStorage("resendEmail");
		}
	}

	handleSignInForm = async () => {
		if (this.state.username.trim() === "") {
			this.setState({
				fieldUsername: {
					show: true,
					status: "error",
					message: "This field cannot be empty.",
				},
			});
			return;
		}

		if (this.state.password.trim() === "") {
			this.setState({
				fieldPassword: {
					show: true,
					status: "error",
					message: "This field cannot be empty.",
				},
			});
			return;
		}

		const payload = {
			data: JSON.stringify({
				username: this.state.username,
				password: this.state.password,
			}),
		};

		await this.props.authSignin(payload);

		if (this.props.signinResponse.httpStatus === 200) {
			setHtmlStorage("accessToken", this.props.signinResponse.data.token);
			setHtmlStorage("userData", this.state.username);
			// setHtmlStorage("AIGreet", this.props.signinResponse.data.greet);
			// if (!statusHtmlStorage("accessDate")) {
			// 	setHtmlStorage("accessDate", dayjs().toISOString());
			// }
			window.location.href = "/splash";
		}

		if (
			this.props.signinResponse.httpStatus === 401 &&
			this.props.signinResponse.data.message ===
				"This Email Is Exist in Our System but not Confiremd yet Please Confirm your Email"
		) {
			setHtmlStorage("resendEmail", this.props.signinResponse.data.email);
			this.setState({
				alertState: {
					show: true,
					variant: "error",
					message:
						"This e-mail is exist in our system but not confirmed yet, please confirm your e-mail.",
				},
			});
			setTimeout(() => {
				window.location.href = "/resend-email-confirmation";
			}, 3000);
		}

		if (
			this.props.signinResponse.httpStatus === 401 &&
			typeof this.props.signinResponse.data !== "object"
		) {
			this.setState({
				alertState: {
					show: true,
					variant: "error",
					message: this.props.signinResponse.data,
				},
			});
		}
	};

	handleInputChange = (evt) => {
		const { name, value } = evt.target;
		this.setState({ [name]: value });
		if (name === "username") {
			this.setState({
				fieldUsername: {
					show: false,
					status: "",
					message: "",
				},
			});
		}
		if (name === "password") {
			this.setState({
				fieldPassword: {
					show: false,
					status: "",
					message: "",
				},
			});
		}
	};

	render() {
		return (
			<>
				<SplashScreen />
				<div className={styles.auth_signin_page}>
					<div className={styles.auth_wrapper}>
						<Typography.Title
							level={3}
							className={styles.auth_signin_title}
						>
							Sign In
						</Typography.Title>
						{this.state.alertState.show && (
							<Alert
								closable
								type={this.state.alertState.variant}
								message={this.state.alertState.message}
								onClose={() =>
									this.setState({
										alertState: {
											show: false,
											variant: "error",
											message: "",
										},
									})
								}
							/>
						)}
						<Form
							colon={false}
							autoComplete="off"
							layout="vertical"
							onFinish={this.handleSignInForm}
						>
							<Form.Item
								hasFeedback={this.state.fieldUsername.show}
								validateStatus={this.state.fieldUsername.status}
								help={this.state.fieldUsername.message}
							>
								<Input
									placeholder="Username"
									name="username"
									prefix={<FiUser />}
									value={this.state.username}
									onChange={this.handleInputChange}
								/>
							</Form.Item>
							<Form.Item
								hasFeedback={this.state.fieldPassword.show}
								validateStatus={this.state.fieldPassword.status}
								help={this.state.fieldPassword.message}
							>
								<Input.Password
									placeholder="Password"
									name="password"
									prefix={<FiLock />}
									value={this.state.password}
									onChange={this.handleInputChange}
								/>
							</Form.Item>
							<Link
								to="/forgot-password"
								className={styles.auth_signin_forgot}
							>
								Forgot password?
							</Link>
							<Button
								type="primary"
								htmlType="submit"
								loading={this.props.loading}
								className={styles.btn_signin}
							>
								Sign in
							</Button>
							<Typography.Text
								className={styles.auth_signin_account}
							>
								Don’t have an account?&nbsp;
								<Link to="/signup">Sign Up</Link>
							</Typography.Text>
						</Form>
					</div>
				</div>
			</>
		);
	}
}

const stateToProps = (state) => {
	const { auth } = state;
	return {
		loading: auth.loading,
		signinResponse: auth.signinResponse,
	};
};

const dispatchToProps = (dispatch) => ({
	authSignin: (payload) => dispatch(authSignin(payload)),
});

export default connect(stateToProps, dispatchToProps)(SignIn);
